import { axisBottom as axis } from 'd3-axis'
import * as time from 'd3-time'
import * as d3 from 'd3-selection'
import * as array from 'd3-array'

const draw = function (scaler, chart) {
  let chartData = chart.datum()
    , axesConfig = chartData.axes
    , height = chartData.dimensions.height
    , padding = 10
    , width = scaler.x.groupScale.range()[1] + 30 // Max width + 30 (padding from x-scaler)
    , ticks = Math.max(Math.abs(width / 100), 2)
    , days = time.timeDay.range(scaler.x.groupScale.domain()[0], scaler.x.groupScale.domain()[1])
    , skip = Math.ceil(days.length / ticks)
    , _axis = axis().scale(scaler.x.groupScale)
                    .tickSize(-height)
                    .tickValues(days.filter(function (d, i) {
                      return !(i % skip)
                    }))
                    .tickPadding(10)

  let draw = function (selection) {
    selection.each(function (data) {
      _axis.tickFormat('')

      let x = d3.select(this)
                .selectAll('g.axis.axis-x')
                .data([_axis.tickValues()])
        , group = x.enter()
                   .append('g')
                    .attr('class', 'axis axis-x')
                     .merge(x)
                     .attr('transform', 'translate(0, ' + (height + padding) + ')')
                     .call(_axis)

      group.selectAll('text') // Created by d3's axis component
           .attr('dy', '0')
           .selectAll('tspan')
           .data(function (d) {
             let formatted = axesConfig.bottom.formatter(d)
             return [formatted.title, formatted.subtitle]
           })
           .enter()
             .append('tspan')
             .text(String)
             .attr('x', 0)
             .filter(function (d, i) {
               return i > 0
             })
             .attr('dy', '1.2em')
             .classed('subtitle', true)

      group.select('path.domain').remove()
    })
  }

  return draw

}

draw.heights = function (container) {
  let result = {
    ticks: 0,
    title: 0
  }
  container.selectAll('.axis-x')
           .nodes()
           .forEach(function (axis) {
             let _axis = d3.select(axis)
             result.ticks = Math.max(array.max(_axis.selectAll('text').nodes(), node => node.getBBox().height), result.ticks)
           })
  return result
}

export default draw
